"use client";

function ServicePage(props: { yScroll?: number }) {
  return (
    <div className="full-screen py-24 px-2 md:px-[5%] flex items-center justify-center">
      <div className="container">
        <div className="block md:flex md:justify-center gap-12 mb-4">
          <h1 className="text-2xl text-black font-medium md:w-1/2 lg:w-5/12 xl:w-1/3 h-auto ">
            Service
          </h1>
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit" />
        </div>
        <div className="block md:flex md:justify-center gap-12">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Our Services</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>We offer focused quantity surveying services including:</div>
              <div>• Cost planning and estimation</div>
              <div>• Tender documentation and evaluation</div>
              <div>• Contract administration</div>
              <div>• Final account preparation</div>
            </div>
          </div>
          <img
            src="/images/service/1.jpg"
            alt="1"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Our Approach</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>As a compact firm, we pride ourselves on:</div>
              <div>• Delivering personalized attention to each client</div>
              <div>
                • Combining technical expertise with practical site knowledge
              </div>
              <div>
                • Maintaining flexibility to adapt to project-specific needs
              </div>
            </div>
          </div>
          <img
            src="/images/service/2.jpg"
            alt="2"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Our Clients</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>We primarily serve:</div>
              <div>• Local contractors</div>
              <div>• Small-to-medium developers</div>
              <div>• Private project owners</div>
              <div>• Architectural practices</div>
            </div>
          </div>
          <img
            src="/images/service/3.jpg"
            alt="3"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
        <div className="block md:flex md:justify-center gap-12 mt-8">
          <div className="md:w-1/2 lg:w-5/12 xl:w-1/3 h-fit">
            <h2 className="mt-4 text-lg">Our Project Experience</h2>
            <div className="mt-4 max-w-[500px] text-sm">
              <div>Our portfolio includes​</div>
              <div>• Residential buildings</div>
              <div>• Commercial renovations</div>
              <div>• Small-scale infrastructure works</div>
              <div>• Interior fit-out projects</div>
            </div>
          </div>
          <img
            src="/images/service/4.jpg"
            alt="3"
            className="h-auto object-contain rounded-lg md:w-5/12 lg:w-1/4"
          />
        </div>
      </div>
    </div>
  );
}

export default ServicePage;
